import { useState, useCallback, useEffect, useRef } from 'react';

interface UseAutoDismissMessageOptions {
  duration?: number;
}

export const useAutoDismissMessage = (options?: UseAutoDismissMessageOptions) => {
  const [message, setMessage] = useState<string>('');
  const timeoutRef = useRef<NodeJS.Timeout>();
  const duration = options?.duration || 10000;

  const showMessage = useCallback((newMessage: string) => {
    setMessage(newMessage);
    
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    
    timeoutRef.current = setTimeout(() => {
      setMessage('');
    }, duration);
  }, [duration]);

  const clearMessage = useCallback(() => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    setMessage('');
  }, []);

  useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  return {
    message,
    showMessage,
    clearMessage,
  };
};